import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router, NavigationEnd } from '@angular/router';
import { McBreadcrumbsModule } from 'ngx-breadcrumbs-ui';
import { NdmsRouteResolverGuard } from './../../shared/core/services/ndms-route-resolver.guard';
import { NdmsAuthenticationGuard } from "../../shared/core/interceptors/ndms-authentication.guard";
import { LeftNavResolverGuard } from './../../shared/core/services/left-nav-resolver-guard';
import { HirAccessService } from './shared/core-hir/hir-access.service';
import { HirHomeComponent } from './components/home/home.component';
import { HirPolicyPermissionsService } from './shared/core-hir/hir-policy-permissions.service';
import { HirPolicyPermissionsGuard } from './shared/core-hir/hir-policy-permissions.guard';

const routes: Routes = [
  {
    path: 'hir', redirectTo: '/hir/home', pathMatch: 'full'
  },
  {
    path: 'hir/home',
    component: HirHomeComponent,
    canActivateChild: [NdmsAuthenticationGuard],
    resolve: {
      response: NdmsRouteResolverGuard,
      policies: HirPolicyPermissionsGuard
    },
    data: {
      service: HirAccessService,
      resolvePermissions: HirPolicyPermissionsService.PermissionSets.Core,
      breadcrumbs: 'Home'
    }
  },
  {
    path: 'hir/deployments',
    loadChildren: './deployments/deployments.module#DeploymentsModule',
    resolve: {
      result: LeftNavResolverGuard,
      response: NdmsRouteResolverGuard,
      policies: HirPolicyPermissionsGuard
    },
    data: {
      service: HirAccessService,
      resolvePermissions: HirPolicyPermissionsService.PermissionSets.Core,
      breadcrumbs: 'Deployments'
    }
  },
  {
    path: 'hir/patients',
    loadChildren: './hir-patients/hir-patients.module#HirPatientsModule',
    resolve: {
      result: LeftNavResolverGuard,
      response: NdmsRouteResolverGuard,
      policies: HirPolicyPermissionsGuard
    },
    data: {
      service: HirAccessService,
      resolvePermissions: HirPolicyPermissionsService.PermissionSets.Core,
      breadcrumbs: 'Patients'
    }
  },
  {
    path: 'hir/responders',
    loadChildren: './hir-responders/hir-responders.module#HirRespondersModule',
    resolve: {
      result: LeftNavResolverGuard,
      response: NdmsRouteResolverGuard,
      policies: HirPolicyPermissionsGuard
    },
    data: {
      service: HirAccessService,
      resolvePermissions: HirPolicyPermissionsService.PermissionSets.Core,
      breadcrumbs: 'Responders'
    }
  },
  // {
  //   path: 'hir/deployments',
  //   loadChildren: './deployments/deployments.module#DeploymentsModule',
  //   resolve: {
  //     result: LeftNavResolverGuard,
  //     response: NdmsRouteResolverGuard,
  //     policies: RmsPolicyPermissionsGuard
  //   },
  //   data: {
  //     service: HirAccessService,
  //     resolvePermissions: RmsPolicyPermissionsService.PermissionSets.Core,
  //     breadcrumbs: 'Deployments'
  //   }
  // },
  // {
  //   path: 'hir/system-management',
  //   loadChildren: './hir-system-management/hir-system-management.module#HirSystemManagementModule',
  //   data: {
  //     breadcrumbs: 'System Settings'
  //   },
  //   resolve: {
  //     response: NdmsAuthenticationGuard
  //   }
  // }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    McBreadcrumbsModule.forRoot()
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {

  constructor(private router: Router) {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
  }

}
